import React, { useEffect, useState } from "react";
import FormRoom from "./Components/AddRoom";
import EditRoom from "./Components/EditRoom";
import RoomListCards from "./RoomListCards";
import { hasAddAccess } from "../../../../Common/CheckAccess";

const RoomList = () => {
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshData = () => {
    setRefreshKey(prev => prev + 1);
  };

  const [permissions, setPermissions] = useState([]);
  
    const existingPermissions = localStorage.getItem("checkPermission");
  
    useEffect(() => {
      if (existingPermissions != undefined) {
        const parsedData = JSON.parse(existingPermissions);
        setPermissions(parsedData);
      }
    }, [existingPermissions]);

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room List</h3>
            <div className="col-auto d-flex w-sm-100">
             {hasAddAccess(permissions, "rooms") && <button
                type="button"
                className="btn btn-dark"
                data-bs-toggle="offcanvas"
                data-bs-target="#add-room"
                aria-controls="add-room"
                onClick={() => setSelectedRoom(null)}
              >
                Add Room
              </button>
              }
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <RoomListCards
                refreshKey={refreshKey}
                selectedRoom={selectedRoom}
                setSelectedRoom={setSelectedRoom}
                refreshData={refreshData}
              />
            </div>
          </div>
        </div>
      </div>
      <FormRoom 
        selectedRoom={selectedRoom} 
        setSelectedRoom={setSelectedRoom}
        refreshData={refreshData}
      />
    </div>
  );
};

export default RoomList;
